import React from "react";
import {Route} from "react-router-dom";

interface PublicRouteProps {
  component: React.ComponentType<any>;
  [key: string]: any;
}

const PublicRoute = ({component: Component, ...rest}: PublicRouteProps) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return <Component {...props} {...(rest.props || {})} />;
      }}
    />
  );
};

export default PublicRoute;
